module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-1.d7dfb50b.mp3";